import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../share-components/Navbar';
import ScrollTopBottom from '../share-components/ScrollTopBottom';

const MainLayout = () => {
    return (
        <>
            <Navbar />
            <div className='appContainer'>
                <ScrollTopBottom/>
                <Outlet />
            </div>
        </>
    );
};

export default MainLayout;
